import { useEnableSellerPhoneUpdate } from '../../../../feature-flags/hooks/use-enable-seller-phone-update';
import { useUserHasAdministrationRole } from '../../../../hooks/use-user-role';

export const useShowSellerCommunicationSection = (): boolean => {
  const enableSellerPhoneUpdate = useEnableSellerPhoneUpdate();
  const isUserAnAdmin = useUserHasAdministrationRole();

  return enableSellerPhoneUpdate && isUserAnAdmin;
};
